// src/pages/HomeIntelbras.js
import React from 'react';
import { Helmet } from 'react-helmet';
import './HomeIntelbras.css';
import ContactForm from '../components/ContactForm';

// --- IMPORTAÇÃO DAS IMAGENS ---
import heroBackground from '../assets/intelbras/hero-background.png';
import iconHome from '../assets/intelbras/icon-home.png';
import iconCondo from '../assets/intelbras/icon-condo.png';
import iconBusiness from '../assets/intelbras/icon-business.png';
import solutionAccess from '../assets/intelbras/solution-access.jpg';
import solutionCftv from '../assets/intelbras/solution-cftv.png';
import solutionIntercom from '../assets/intelbras/solution-intercom.png';
import solutionSmartHome from '../assets/intelbras/solution-smart-home.png';
import solutionCondoControl from '../assets/intelbras/solution-condo-control.png';
import solutionWifi from '../assets/intelbras/solution-wifi.png';
import logoPts from '../assets/intelbras/logo-pts.png';
import logoIntelbras from '../assets/intelbras/logo-intelbras.png';

const HomeIntelbras = () => {

  // --- DEFINIÇÃO DO SCHEMA DE DADOS ESTRUTURADOS PARA SEO ---
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Primo Trade Solutions LTDA", // [cite: 20]
    "image": "https://primotradesolutions.com.br/static/media/logo-pts.c7c00e6a8dd288e2c72b.png",
    "@id": "https://primotradesolutions.com.br/",
    "url": "https://primotradesolutions.com.br/",
    "telephone": "+55 11 9 7721-1739", // [cite: 6, 20]
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rua Eugene Carriere, 30, CJ6 T1, Jardim Vertentes", // [cite: 3]
      "addressLocality": "São Paulo", // [cite: 3]
      "addressRegion": "SP", // [cite: 3]
      "postalCode": "05541-100", // [cite: 3]
      "addressCountry": "BR" // [cite: 3]
    },
    "description": "Especialistas em instalação de câmeras de segurança, CFTV, controle de acesso, automação residencial e redes Wi-Fi Intelbras.",
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "09:00",
      "closes": "18:00"
    }
  };

  return (
    <div className="page-intelbras">
      <Helmet>
        {/* SEO BÁSICO */}
        <title>PTS - Instalação de Sistemas Intelbras | Segurança e Automação</title>
        <meta name="description" content="Especialistas em instalação de câmeras de segurança, CFTV, controle de acesso, automação residencial e redes Wi-Fi Intelbras para residências, condomínios e empresas." />
        
        {/* OG TAGS PARA REDES SOCIAIS */}
        <meta property="og:title" content="PTS - Sistemas Intelbras: Segurança e Automação para seu Espaço" />
        <meta property="og:description" content="Especialistas em instalação de câmeras de segurança, CFTV, controle de acesso e Wi-Fi Intelbras para residências, condomínios e empresas." />
        <meta property="og:image" content="https://primotradesolutions.com.br/static/media/logo-pts.c7c00e6a8dd288e2c72b.png" />
        <meta property="og:url" content="https://primotradesolutions.com.br/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Primo Trade Solutions" />
        
        {/* SCRIPT DE SCHEMA MARKUP */}
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      </Helmet>
      
      {/* --- Bloco 1: Herói --- */}
      <section 
        className="hero-section" 
        style={{ backgroundImage: `linear-gradient(rgba(44, 62, 80, 0.7), rgba(44, 62, 80, 0.7)), url(${heroBackground})` }}
      >
        <div className="container">
          <h1>Sua casa está segura agora? Imagine ela te dando as boas-vindas.</h1>
          <p className="subtitle">
            Transformamos residências e empresas em fortalezas inteligentes. Veja o futuro de tranquilidade e conveniência que podemos construir para você.
          </p>
          <a href="#contato" className="hero-cta">Peça seu Orçamento</a>
        </div>
      </section>

      {/* --- Bloco 2: Segmentos --- */}
      <section id="segmentos" className="intelbras-section segments-section">
        <div className="container">
          <h2>Soluções Sob Medida para Cada Necessidade</h2>
          <div className="segments-container">
            <a href="#contato" className="segment-card-link">
              <div className="segment-card">
                <img src={iconHome} alt="Ícone de Casa Inteligente" />
                <h3>Para sua Casa</h3>
                <p>Para você, que zela pela segurança e conforto da sua família.</p>
              </div>
            </a>
            <a href="#contato" className="segment-card-link">
              <div className="segment-card">
                <img src={iconCondo} alt="Ícone de Condomínio Seguro" />
                <h3>Para seu Condomínio</h3>
                <p>Para o síndico que busca eficiência, controle e valorização do patrimônio.</p>
              </div>
            </a>
            <a href="#contato" className="segment-card-link">
              <div className="segment-card">
                <img src={iconBusiness} alt="Ícone de Empresa Protegida" />
                <h3>Para sua Empresa</h3>
                <p>Para o gestor que não aceita nada menos que otimização e segurança total.</p>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* --- Bloco 3: Galeria --- */}
      <section id="solucoes" className="intelbras-section">
        <div className="container">
          <h2>Nossas Especialidades de Instalação</h2>
          <p>Não vendemos produtos, entregamos soluções que transformam seu dia a dia.</p>
          <div className="solutions-gallery">
            <div className="solution-item" style={{ backgroundImage: `url(${solutionAccess})` }}>
              <h4>Acesso Sem Chaves</h4>
            </div>
            <div className="solution-item" style={{ backgroundImage: `url(${solutionCftv})` }}>
              <h4>Tudo na Palma da Mão</h4>
            </div>
            <div className="solution-item" style={{ backgroundImage: `url(${solutionIntercom})` }}>
              <h4>Atenda de Onde Estiver</h4>
            </div>
            <div className="solution-item" style={{ backgroundImage: `url(${solutionSmartHome})` }}>
              <h4>Sua Casa Inteligente</h4>
            </div>
            <div className="solution-item" style={{ backgroundImage: `url(${solutionCondoControl})` }}>
              <h4>Controle Total do Condomínio</h4>
            </div>
            <div className="solution-item" style={{ backgroundImage: `url(${solutionWifi})` }}>
              <h4>Rede Wi-Fi de Alta Performance</h4>
            </div>
          </div>
        </div>
      </section>

      {/* --- Bloco 3.5: Lista de Serviços --- */}
      <section id="servicos" className="intelbras-section services-section">
        <div className="container">
          <h2>Todos os Nossos Serviços de Instalação</h2>
          <p>Da consultoria inicial ao suporte pós-venda, cobrimos todas as suas necessidades em tecnologia e segurança.</p>
          <div className="services-grid">
            <div className="service-category">
              <h3>Segurança Eletrônica</h3>
              <ul>
                <li>Instalação de Câmeras de Segurança Intelbras</li>
                <li>Sistema de CFTV IP e Analógico</li>
                <li>Manutenção de Sistemas de Vigilância</li>
                <li>Instalação de Alarmes Monitorados</li>
                <li>Configuração de Gravadores (DVR/NVR)</li>
                <li>Instalação de Cerca Elétrica</li>
              </ul>
            </div>
            <div className="service-category">
              <h3>Redes e Conectividade</h3>
              <ul>
                <li>Instalação e Configuração de Roteadores</li>
                <li>Implementação de Redes Wi-Fi Mesh</li>
                <li>Soluções de Wi-Fi Corporativo</li>
                <li>Cabeamento Estruturado</li>
                <li>Configuração de Rede Local (LAN)</li>
              </ul>
            </div>
            <div className="service-category">
              <h3>Automação Residencial</h3>
              <ul>
                <li>Projetos de Casa Inteligente</li>
                <li>Integração com Amazon Alexa e Google</li>
                <li>Instalação de Iluminação Inteligente</li>
                <li>Automação de Cortinas e Persianas</li>
                <li>Sonorização de Ambientes</li>
              </ul>
            </div>
            <div className="service-category">
              <h3>Controle de Acesso</h3>
              <ul>
                <li>Instalação de Videoporteiro</li>
                <li>Instalação de Fechadura Digital e Biométrica</li>
                <li>Sistemas para Condomínios</li>
                <li>Controle de Acesso Corporativo</li>
              </ul>
            </div>
            <div className="service-category">
              <h3>Infraestrutura de TI</h3>
              <ul>
                <li>Montagem e Manutenção de Servidores</li>
                <li>Montagem e Manutenção de Computadores</li>
                <li>Suporte Técnico em TI para Empresas</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* --- Bloco 4: Selo de Confiança --- */}
      <section className="intelbras-section trust-section">
          <div className="container">
              <h2>Parceria de Confiança</h2>
              <p>Unimos a liderança de mercado da Intelbras com a nossa excelência em instalação e configuração.</p>
              <div className="logos-container">
                  <div className="logo-placeholder">
                      <img src={logoPts} alt="Logo Primo Trade Solutions" />
                  </div>
                  <div className="plus-icon">+</div>
                  <div className="logo-placeholder">
                      <img src={logoIntelbras} alt="Logo Intelbras" />
                  </div>
              </div>
          </div>
      </section>

      {/* --- Bloco 5: Captura (Formulário) --- */}
      <section id="contato" className="intelbras-section capture-section">
        <div className="container">
          <h2>Inicie sua transformação agora.</h2>
          <p>
            Devido à alta demanda por projetos customizados, nossa agenda de avaliações técnicas para o próximo mês possui vagas limitadas. Preencha o formulário para garantir a sua.
          </p>
          <ContactForm />
        </div>
      </section>
    </div>
  );
};

export default HomeIntelbras;